"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hurtFireAt = exports.spirals = exports.calcSpiral = void 0;
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var calcSpiral = function (r) {
    var spiral = [];
    var add = function (ox, oy) {
        spiral.push({ x: ox, y: oy });
    };
    if (r >= 0) {
        add(0, 0);
    }
    if (r >= 0.5) {
        add(-1, 0);
        add(0, -1);
        add(1, 0);
        add(0, 1);
    }
    if (r >= 1.5) {
        add(-1, -1);
        add(1, -1);
        add(1, 1);
        add(-1, 1);
    }
    if (r >= 2) {
        add(-2, 0);
        add(0, -2);
        add(2, 0);
        add(0, 2);
    }
    if (r >= 2.5) {
        add(-2, -1);
        add(-1, -2);
        add(1, -2);
        add(2, -1);
        add(2, 1);
        add(1, 2);
        add(-1, 2);
        add(-2, 1);
    }
    if (r >= 3) {
        add(-3, 0);
        add(0, -3);
        add(3, 0);
        add(0, 3);
    }
    return spiral;
};
exports.calcSpiral = calcSpiral;
exports.spirals = {
    0: (0, exports.calcSpiral)(0),
    0.5: (0, exports.calcSpiral)(0.5),
    1: (0, exports.calcSpiral)(1),
    1.5: (0, exports.calcSpiral)(1.5),
    2: (0, exports.calcSpiral)(2),
    2.5: (0, exports.calcSpiral)(2.5),
    3: (0, exports.calcSpiral)(3),
};
var hurtFireAt = function (x, y, strength) {
    var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(x, y);
    if (!m)
        return;
    if (m.data.isHellHound) {
        rogueMonsters_sidecar_1.rogueMonsters.damage(m, strength, 'water');
        if (m.hp <= 0) {
            var mNew = rogueMonsters_sidecar_1.rogueMonsters.create('d');
            rogueMonsters_sidecar_1.rogueMonsters.setPos(mNew, x, y);
        }
    }
    if (m.data.isFire) {
        rogueMonsters_sidecar_1.rogueMonsters.damage(m, strength, 'water');
        if (m.data.type === 'F') {
            //m.hp -= strength
            if (m.hp <= 0) {
                //rogueMonsters.kill(m)
                if (strength <= 1) {
                    var newS = rogueMonsters_sidecar_1.rogueMonsters.create('f');
                    rogueMonsters_sidecar_1.rogueMonsters.setPos(newS, x, y);
                }
            }
        }
        if (m.data.type === 'f') {
            //rogueMonsters.kill(m)
        }
    }
};
exports.hurtFireAt = hurtFireAt;
